import styled from 'styled-components';
import { SELECTORS, TABLET_BREAKPOINT, UBISOFT_BLUE } from '../../constants';

export const LegalLinesSection = styled.section`
    ${SELECTORS} & {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 200px;
    }
    
    @media (max-width: 770px) {
        ${SELECTORS} & {
          width: 90%;
          margin: 0 auto 100px auto;
        }
     }
`;

export const LegalLineText = styled.p`
    ${SELECTORS} & {
        margin-bottom: 10px;
        font-size: 13px;
        a {
            color: white;
            text-decoration: underline;
            font-size: 13px;
        }
    }
    @media (max-width: ${TABLET_BREAKPOINT}) {
        ${SELECTORS} & {
            font-size: 12px;
            a {
                font-size: 12px;
            }
        }
    }
`;


export const LegalLineDescription = styled(LegalLineText)`
    ${SELECTORS} & {
        text-decoration: underline;
        margin-bottom: 0;
        margin-top: 25px;
    }
`;
